export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-joomla-3c0f24730e2b35ca2e692049551d7403.svg";